import { render, staticRenderFns } from "./add-customer.vue?vue&type=template&id=13c59db7&scoped=true"
import script from "./add-customer.vue?vue&type=script&lang=js"
export * from "./add-customer.vue?vue&type=script&lang=js"
import style0 from "./add-customer.vue?vue&type=style&index=0&id=13c59db7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c59db7",
  null
  
)

export default component.exports